import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

const ProgressBar = ({
  title,
  percentage,
  displayedText,
  titleWidth,
  units = '%',
  barWidth = 50,
  textWidth = 50,
  textPlacement = 'left',
  backgroundColor = '#5999ff',
  showBarOnly = false,
  hasHtmlTitle = true,
  hoverable,
  className,
  onClick,
}) => {
  const barClassNames = hoverable ? 'progress hoverable' : 'progress';
  const text = displayedText || `${percentage}${units}`;
  const percentageText = <span className="mr-xs ml-xs progress-percentage-text" data-testid="progress-percentage-text" style={{ width: textWidth }}>{text}</span>;
  const showTitle = () => title ? <span className="mr-xs ml-xs progress-title-text" data-testid="progress-title" style={{ width: titleWidth }}>{title}</span> : null;
  return (
    <div className={cx('d-flex align-items-center flex-wrap', className)} data-testid="progress-wrapper">
      {!showBarOnly && textPlacement === 'left' ? percentageText : showTitle()}
      <div
        className={barClassNames}
        style={{ width: barWidth, cursor: !onClick || hoverable ? 'default' : 'pointer' }}
        data-testid="progress-box"
        onClick={onClick}
      >
        <div
          title={hasHtmlTitle ? text : null}
          className="progress-bar"
          data-testid="progress-bar"
          style={{ width: `${percentage}%`, backgroundColor: `${backgroundColor}` }}
        />
      </div>
      {!showBarOnly && textPlacement === 'right' ? percentageText : showTitle()}
    </div>
  );
};

ProgressBar.propTypes = {
  percentage: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  backgroundColor: PropTypes.string,
  textPlacement: PropTypes.string,
  showBarOnly: PropTypes.bool,
  hasHtmlTitle: PropTypes.bool,
  hoverable: PropTypes.bool,
  className: PropTypes.string,
  title: PropTypes.string,
  units: PropTypes.string,
  displayedText: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  textWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  barWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  titleWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onClick: PropTypes.func,
};

export default ProgressBar;
